module.exports = __webpack_public_path__ + "static/img/hire_768.d1fe722.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hellohr/hire_768.png
// module id = eBOP
// module chunks = 0